module.exports = __webpack_public_path__ + "img/login-bg2.907bc751.png";